export default {
  accountConfig: [],

  taxTable: [],
  taxTableById: [],
  taxTableIsValid: null,
  taxTableLastRecord: null,

  occupationCategory: [],
  occupationCategoryById: [],
  occupationCategoryCode: null,

  nationalityType: [],
  nationalityTypeById: [],
  nationalityTypeCode: null,

  workPlaceStatus: [],
  workPlaceStatusById: [],
  workPlaceStatusCode: null,

  exemptionType: [],
  exemptionTypeById: [],
  exemptionTypeCode: null,

  excelSample: [],
  excelSampleById: [],
  excelSampleDetail: [],
  excelSampleData: [],
  excelSampleId: null,
  excelSampleMaxColumnIndex: null,

  benefitsAndDeduction: [],
  benefitsAndDeductionById: [],
  benefitsAndDeductionCode: null,
  benefitsAndDeductionPriority: null,

  insuranceWorkplace: [],
  insuranceWorkplaceById: [],
  insuranceWorkplaceCode: null,

  settings: [],

  employeePortalAccess: null,

  workingHours: [],
  workingHourById: [],

  agreementRows: [],
  agreementRowById: [],
  agreementRowCode: null,

  jobGroups: [],
  jobGroupById: {},
  jobGroupCode: null,

  contractTypes: [],
  contractTypeById: [],
  contractTypeCode: null,

  additionalContractParameters: [],

  parameterValues: [],

  contractSamples: [],
  contractSampleById: [],
  contractSampleCode: null,
  contractSampleId: null,
  contractSampleNavigation: null,

  contracts: [],
  contractById: [],
  contractCode: null,
  contractId: null,
  contractNavigation: null,

  formulas: [],
  formulaById: [],
  formulaCode: null,
  formulaPriority: null,
  formulaId: null,

  payrollEmployees: [],
  payrollEmployee: {},
  payrollEmployeeContracts: [],
  payrollEmployeeVoucher: [],
  payrollEmployeePayment: [],
  payrollEmployeeDirectVoucher: [],
  payrollEmployeeNavigation: {},
  payrollEmployeeCalculate: {},
  payrollEmployeeImportPreview: null,

  taxRateTypes: [],

  printLink: {},
  payrollEmployeeReport: [],
  employeePayrollSummaryPersonnelReport: [],
  employeePayrollSummaryPersonnelDetail: [],
  payrollEmployeeSummaryReport: [],
  payrollEmployeeSummaryInsuranceWorkplaceReport: [],
  advanceReport: [],

  payslipReport: [],

  insuranceEmployees: [],
  insuranceEmployee: {},
  insuranceEmployeeId: null,
  insuranceEmployeeContracts: [],
  insuranceEmployeeNavigation: {},

  taxEmployees: [],
  taxEmployee: {},
  taxEmployeeId: null,
  taxEmployeeContracts: [],
  taxEmployeeNavigation: {},

  leaves: [],
  leaveById: [],
  leaveCode: null,
  leaveNavigation: {},
  leaveConfirm: [],
  leaveManagementCartable: [],
  missions: [],
  missionById: [],
  missionCode: null,
  missionNavigation: {},
  missionConfirm: [],
  missionManagementCartable: [],

  advances: [],
  advanceById: [],
  advanceCode: null,
  advanceId: null,
  advanceNavigation: {},
  advanceConfirm: [],
  advanceManagementCartable: [],
  cartableLog: [],
  advanceVoucher: [],
  advanceVoucherId: null,
  advanceVoucherNumber: null,

  bankExportTemplates: [],
  bankExportTemplateById: {},
  bankExportTemplateCode: null,
  bankExportTemplateId: null,
  bankExportTemplateDeleteError: null,
  bankExportVariables: [],
  bankExportPreview: {},
  bankExportError: null,
  bankExportHistory: [],
  bankExportHistoryDetail: [],
  bankExportPayrolls: [],

  payroll: {},
};
